module.exports = {"book":["book","book"],"book_section":["book","bookitem"],"journal":["journal","article"],"conference_proceedings":["journal","proceeding"],"report":["journal","report"],"generic":["journal","unknown"]}


//////////////////
// WEBPACK FOOTER
// ./src/universal/ui/utils/open-url/type-genre-map.json
// module id = 1063
// module chunks = 1